import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { SELECT_REGION } from '../../../constants/UrlConstants';
import { getLangCountryPrefix } from '../../../helpers/utils';
import promoColors from '../../../theme/promoColors';
import { LightFlagIcon } from '../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { PromoText } from '../common/PromoText/PromoText';

const Region = styled.div`
    a {
        white-space: nowrap;
        display: flex;
        align-items: center;
        padding: 10px 0;
        color: ${promoColors.gray80};
    }

    a:link,
    a:visited {
        color: ${promoColors.gray80};
    }

    a:hover {
        color: ${promoColors.gray40};
    }

    a:focus-visible {
        background-color: ${promoColors.gray20};
        border-radius: 2px;
        outline: 1px dashed ${promoColors.gray40};
    }
`;

const CountryName = styled.span`
    display: inline-block;
    margin-left: 8px;
`;

const FooterCountry = (props) => {
    const { countryCode, countryName, country } = props;
    const location = useLocation();
    const navigate = useNavigate();

    const onClick = () => {
        let prefix = getLangCountryPrefix(props.lang, country);
        const url = `${prefix}${SELECT_REGION}`;
        let pathname = location.pathname;
        let slug = null;

        if (pathname.indexOf(prefix) != '-1') {
            slug = pathname.slice(7);
        } else {
            slug = pathname.slice(1);
        }

        navigate(url, { state: { prevSlug: slug } });
        sessionStorage?.setItem('prevSlug', slug);
    };
    return (
        <Region>
            <PromoText
                tag="link"
                onClick={onClick}
                href={`${getLangCountryPrefix(props.lang, country)}${SELECT_REGION}`}
                data-testid="footer-country-link-region"
            >
                <LightFlagIcon name={countryCode} size="24px" />
                <CountryName>{countryName}</CountryName>
            </PromoText>
        </Region>
    );
};

FooterCountry.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
    };
};

export default connect(mapStateToProps, null)(FooterCountry);
